class AvHomePromotion {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        document.querySelectorAll('[data-home-promotion]').forEach((element) => {
            this.setupPromotion(element);
        });
    }

    setupPromotion(element) {
        const campaignKey = element.dataset.campaignKey;

        if (!campaignKey || !this.shouldShow(element)) {
            return;
        }

        const closeButton = element.querySelector('[data-home-promotion-close]');
        const focusableElements = () => Array.from(element.querySelectorAll('a[href], button:not([disabled])'));
        let previousFocus = null;

        const open = () => {
            previousFocus = document.activeElement;
            element.hidden = false;
            element.setAttribute('aria-hidden', 'false');
            document.body.classList.add('has-home-promotion');

            window.setTimeout(() => {
                closeButton?.focus();
            }, 0);
        };

        const close = () => {
            this.rememberDismissal(campaignKey);
            element.hidden = true;
            element.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('has-home-promotion');

            if (previousFocus && typeof previousFocus.focus === 'function') {
                previousFocus.focus();
            }
        };

        const handleKeyDown = (event) => {
            if (element.hidden) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            const items = focusableElements();

            if (items.length === 0) {
                return;
            }

            const first = items[0];
            const last = items[items.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        };

        closeButton?.addEventListener('click', close);
        document.addEventListener('keydown', handleKeyDown);
        open();
    }

    shouldShow(element) {
        const campaignKey = element.dataset.campaignKey;
        const cooldownDays = Math.max(0, Number.parseInt(element.dataset.dismissCooldownDays || '30', 10));
        const storageKey = this.storageKey(campaignKey);
        const dismissedAt = this.getDismissedAt(storageKey);

        if (!dismissedAt) {
            return true;
        }

        const cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;

        return Date.now() - dismissedAt >= cooldownMs;
    }

    rememberDismissal(campaignKey) {
        try {
            window.localStorage.setItem(this.storageKey(campaignKey), JSON.stringify({
                dismissedAt: Date.now(),
            }));
        } catch (error) {
            // localStorage can be unavailable in private browsing; the modal should still close.
        }
    }

    getDismissedAt(storageKey) {
        try {
            const stored = window.localStorage.getItem(storageKey);

            if (!stored) {
                return null;
            }

            const parsed = JSON.parse(stored);
            const dismissedAt = Number.parseInt(parsed.dismissedAt, 10);

            return Number.isNaN(dismissedAt) ? null : dismissedAt;
        } catch (error) {
            return null;
        }
    }

    storageKey(campaignKey) {
        return `fustudio.sitePromotion.${campaignKey}`;
    }
}

export default AvHomePromotion;
